var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHcraLogoColor = function SvgHcraLogoColor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 962.6 408.9",
    style: {
      enableBackground: "new 0 0 962.6 408.9"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st1{fill:#35393C;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456E88"
    },
    d: "M357.2,93.7v-0.2l-88-29.3V5.6H269V5.6H63.7v0.1h0V123L5,152.2V387h0v0h352.1v0h0L357.2,93.7L357.2,93.7z  M93.1,34.9h146.7v205.4l-117.3-58.7l-29.4,19.6V34.9z M34.4,167l29.3-14.7v68.5l-29.3,19.6V167z M93.1,357.7H34.4v-88.1 l88.1-58.7l33.4,16.7l-62.8,42L93.1,357.7z M269.1,357.7H122.4v-78.3l58.6-39.2l58.8,29.4v0h0l29.3,14.7V357.7z M327.8,357.7 h-29.3l0-88L269.1,255V93.5l58.7,19.6V357.7z"
  }))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M456.2,93.6l0,56.1h-18.9l0-20.7h-17.5l0,20.7h-18.9l0-56.1h18.9l0,19.9h17.5l0-19.9H456.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M462.6,127.8c0-13.3,10.7-22.7,25.5-22.7c14.9,0,25.5,9.4,25.5,22.7c0,13.3-10.6,22.8-25.5,22.8 C473.3,150.5,462.6,141.1,462.6,127.8z M495.2,127.7c0-5.7-3.1-8.6-7.1-8.6c-4,0-7.1,2.9-7.1,8.6c0,5.7,3.1,8.7,7.1,8.7 C492.1,136.4,495.2,133.4,495.2,127.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M594.6,124.7l0,25l-18.1,0l0-21.9c0-5.4-2-7.5-4.9-7.5c-3.2,0-5.7,2.2-5.7,8l0,21.4h-18.1l0-21.9 c0-5.4-1.8-7.5-4.9-7.5c-3.2,0-5.7,2.2-5.7,8l0,21.4h-18.1l0-43.8h17.2v4.1c3.3-3.3,7.6-4.9,12.4-4.9c5.7,0,10.7,2.1,13.7,6.7 c3.5-4.2,8.7-6.7,14.7-6.7C587,105.1,594.6,110.9,594.6,124.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M648.5,132H618c1.3,3.4,4.3,5.1,8.8,5.1c4,0,6.3-1,9.1-3.2l9.5,9.5c-4.2,4.6-10.4,7.1-19.2,7.1 c-16.1,0-26.5-9.7-26.5-22.8c0-13.3,10.7-22.7,24.8-22.7c13,0,24.1,7.9,24.1,22.7C648.7,129,648.6,130.7,648.5,132z M617.7,123.3 h14.1c-0.7-3.7-3.4-5.8-7.1-5.8C621,117.4,618.4,119.6,617.7,123.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M398.7,200.8c0-17.2,13.2-29.3,31.3-29.3c11,0,19.6,4,25.2,11.2l-11.9,10.7c-3.3-4.2-7.2-6.6-12.3-6.6 c-7.9,0-13.1,5.4-13.1,14c0,8.6,5.3,14,13.1,14c5,0,9-2.4,12.3-6.6l11.9,10.7c-5.5,7.2-14.2,11.2-25.2,11.2 C411.9,230.1,398.7,218,398.7,200.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M456.5,206.9c0-13.3,10.7-22.7,25.5-22.7c14.9,0,25.5,9.4,25.5,22.7c0,13.3-10.6,22.8-25.5,22.8 C467.2,229.6,456.5,220.2,456.5,206.9z M489.1,206.8c0-5.7-3.1-8.6-7.1-8.6c-4,0-7.1,2.9-7.1,8.6c0,5.7,3.1,8.7,7.1,8.7 C486,215.5,489.1,212.5,489.1,206.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M561.4,203.8l0,25h-18.1l0-21.9c0-5.4-2.1-7.5-5.4-7.5c-3.7,0-6.8,2.3-6.8,8.8l0,20.6h-18.1l0-43.8h17.2v4.3 c3.4-3.4,8.1-5.1,13.2-5.1C553.5,184.2,561.4,190,561.4,203.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M566.4,225.3l5-11.9c4.2,2.5,10.1,3.9,15.3,3.9c4.4,0,5.6-0.8,5.6-2.1c0-4.5-25.2,1.5-25.2-16 c0-8.3,7.7-15,22.4-15c6.4,0,13.2,1.2,17.9,3.6l-5,11.9c-4.5-2.5-9-3.2-12.7-3.2c-4.6,0-5.9,1-5.9,2.1c0,4.6,25.2-1.4,25.2,16.2 c0,7.9-7.5,14.8-22.7,14.8C578.7,229.6,570.9,227.8,566.4,225.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M646.5,227.3c-2.8,1.6-6.9,2.3-11.1,2.3c-12.1,0-19.2-5.7-19.2-17.8v-11.2h-6l0-13.2h6v-12.3h18.1v12.3h9 l0,13.2h-9v11.1c0,2.7,1.6,4.2,3.8,4.2c1.4,0,2.9-0.4,4.1-1.2L646.5,227.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M682.3,184.2l0,16c-1.6-0.2-2.7-0.3-4-0.3c-5.4,0-9.3,2.5-9.3,9.5l0,19.5h-18.1l0-43.8h17.2v4.7 C671.3,186,676.2,184.2,682.3,184.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M734.6,185l0,43.8h-17.2v-4.2c-3.3,3.4-7.7,5-12.4,5c-10.5,0-18.4-6.2-18.4-20.4l0-24.2l18.1,0l0,21.1 c0,6.3,2.2,8.3,5.7,8.3c3.1,0,6.2-2.3,6.2-8.8l0-20.6H734.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M740,206.8c0-13.3,10.7-22.7,25.9-22.7c10.7,0,18.7,4.9,21.6,13l-14,6.9c-1.8-4.1-4.5-5.8-7.6-5.8 c-4.1,0-7.5,2.9-7.5,8.6c0,5.8,3.4,8.7,7.5,8.7c3.1,0,5.8-1.7,7.6-5.8l14,6.9c-2.9,8.1-10.9,13-21.6,13 C750.8,229.6,740,220.2,740,206.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M825.1,227.3c-2.8,1.6-6.9,2.3-11.1,2.3c-12.1,0-19.2-5.7-19.2-17.8v-11.2h-6l0-13.2h6v-12.3l18.1,0v12.3h9 l0,13.2h-9v11.1c0,2.7,1.6,4.2,3.8,4.2c1.4,0,2.9-0.4,4.1-1.2L825.1,227.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M827.7,172.2c0-5.2,4.2-9.2,10.9-9.2c6.7,0,10.9,3.7,10.9,8.9c0,5.5-4.2,9.5-10.9,9.5 C831.9,181.4,827.7,177.4,827.7,172.2z M829.5,185h18.1l0,43.8h-18.1L829.5,185z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M852.7,206.8c0-13.3,10.7-22.7,25.5-22.7c14.9,0,25.5,9.4,25.5,22.7c0,13.3-10.6,22.8-25.5,22.8 C863.4,229.6,852.7,220.1,852.7,206.8z M885.3,206.8c0-5.7-3.1-8.6-7.1-8.6c-4,0-7.1,2.9-7.1,8.6s3.1,8.7,7.1,8.7 C882.2,215.5,885.3,212.5,885.3,206.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M957.5,203.8l0,25h-18.1l0-21.9c0-5.4-2.1-7.5-5.4-7.5c-3.7,0-6.8,2.3-6.8,8.8l0,20.6h-18.1l0-43.8h17.2v4.3 c3.4-3.4,8.1-5.1,13.2-5.1C949.7,184.2,957.5,190,957.5,203.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456E88"
    },
    d: "M425,293.8h-5.1l0,14.1h-18.9l0-56.1h27c15.6,0,25.6,8.2,25.6,21.2c0,8.1-3.8,14.2-10.6,17.6l11.8,17.3h-20.2 L425,293.8z M426.7,266.4h-6.9l0,13.1h6.9c5.2,0,7.7-2.5,7.7-6.6C434.4,268.9,431.9,266.4,426.7,266.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456E88"
    },
    d: "M505.9,290.2l-30.5,0c1.3,3.4,4.3,5.1,8.8,5.1c4,0,6.3-1,9.1-3.2l9.5,9.5c-4.2,4.6-10.4,7.1-19.2,7.1 c-16.1,0-26.5-9.7-26.5-22.8c0-13.3,10.7-22.7,24.8-22.7c13,0,24.1,7.9,24.1,22.7C506.1,287.2,506,288.9,505.9,290.2z  M475.1,281.5l14.1,0c-0.7-3.7-3.4-5.8-7.1-5.8C478.4,275.6,475.8,277.8,475.1,281.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456E88"
    },
    d: "M560.3,264.1l0,35.1c0,17-9.9,25.1-26.7,25.1c-8.7,0-16.5-1.8-22-5.5l6.1-12.3c3.4,2.6,9.3,4.3,14,4.3 c7.5,0,10.4-3.3,10.4-9.1v-0.8c-2.7,3.1-6.7,4.6-12.1,4.6c-11.1,0-21.1-8.2-21.1-21.2c0-13,9.9-21.1,21.1-21.1 c6,0,10.3,1.8,13,5.8v-5H560.3z M542.4,284.3c0-4.2-3.2-7-7.5-7c-4.2,0-7.5,2.7-7.5,7s3.3,7.1,7.5,7.1S542.4,288.6,542.4,284.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456E88"
    },
    d: "M616,264.1l0,43.8h-17.2v-4.2c-3.3,3.4-7.7,5-12.4,5c-10.5,0-18.4-6.2-18.4-20.4l0-24.2h18.1l0,21.1 c0,6.3,2.2,8.3,5.7,8.3c3.1,0,6.2-2.3,6.2-8.8l0-20.6H616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456E88"
    },
    d: "M623.9,248.4h18.1l0,59.5h-18.1L623.9,248.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456E88"
    },
    d: "M693.1,284.3l0,23.6h-16.8v-5.8c-2.1,4.4-6.3,6.6-12.4,6.6c-10.7,0-16.3-6.1-16.3-13.6 c0-8.5,6.4-13.2,20-13.2h7.3c-0.6-3.4-3.1-5.1-8.3-5.1c-3.9,0-8.3,1.3-11.2,3.4l-5.8-11.9c5.1-3.2,12.9-5,19.7-5 C684.4,263.3,693.1,269.8,693.1,284.3z M675,293.6v-3h-4.5c-3.8,0-5.5,1.3-5.5,3.7c0,2,1.6,3.5,4.3,3.5 C671.8,297.8,674,296.5,675,293.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456E88"
    },
    d: "M732.7,306.4c-2.8,1.6-6.9,2.3-11.1,2.3c-12.1,0-19.2-5.7-19.2-17.8v-11.2h-6l0-13.2h6l0-12.3h18.1l0,12.3h9 l0,13.2h-9v11.1c0,2.7,1.6,4.2,3.8,4.2c1.4,0,2.9-0.4,4.1-1.2L732.7,306.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456E88"
    },
    d: "M733.8,285.9c0-13.3,10.7-22.7,25.5-22.7c14.9,0,25.5,9.4,25.5,22.7c0,13.3-10.6,22.8-25.5,22.8 C744.5,308.7,733.8,299.2,733.8,285.9z M766.5,285.9c0-5.7-3.1-8.6-7.1-8.6c-4,0-7.1,2.9-7.1,8.6s3.1,8.7,7.1,8.7 C763.3,294.6,766.5,291.6,766.5,285.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456E88"
    },
    d: "M821.7,263.3l0,16c-1.6-0.2-2.7-0.3-4-0.3c-5.4,0-9.3,2.5-9.3,9.5l0,19.5l-18.1,0l0-43.8l17.2,0v4.7 C810.7,265.1,815.6,263.3,821.7,263.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456E88"
    },
    d: "M876.9,264.1l-18,44.7c-4.8,12-11.9,15.5-21.2,15.5c-4.8,0-10.3-1.5-13.3-3.9l6-12.4c1.8,1.4,4.2,2.3,6.4,2.3 c2.2,0,3.5-0.6,4.5-1.8l-18.4-44.4h18.6l9.1,23.5l9.2-23.5H876.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456E88"
    },
    d: "M439.2,377.2h-21.3l-3.8,9.8h-19.2l24.5-56.1H438l24.5,56.1h-19.6L439.2,377.2z M434,363.6l-5.5-14.1 l-5.4,14.1H434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456E88"
    },
    d: "M511.3,343.2l0,43.8h-17.2v-4.2c-3.3,3.4-7.7,5-12.4,5c-10.5,0-18.4-6.2-18.4-20.4l0-24.2h18.1l0,21.1 c0,6.3,2.2,8.3,5.7,8.3c3.1,0,6.2-2.3,6.2-8.8l0-20.6H511.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456E88"
    },
    d: "M552.3,385.5c-2.8,1.6-6.9,2.3-11.1,2.3c-12.1,0-19.2-5.7-19.2-17.8l0-11.2h-6v-13.2h6l0-12.3h18.1l0,12.3h9 v13.2h-9l0,11.1c0,2.7,1.6,4.2,3.8,4.2c1.4,0,2.9-0.4,4.1-1.2L552.3,385.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456E88"
    },
    d: "M605.1,362l0,25l-18.1,0l0-21.9c0-5.4-2.1-7.5-5.4-7.5c-3.7,0-6.8,2.3-6.8,8.8l0,20.6h-18.1l0-59.5h18.1 l0,19.2c3.4-2.9,7.6-4.3,12.3-4.3C597.2,342.4,605.1,348.2,605.1,362z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456E88"
    },
    d: "M610.2,365c0-13.3,10.7-22.7,25.5-22.7c14.9,0,25.5,9.4,25.5,22.7c0,13.3-10.6,22.8-25.5,22.8 C620.8,387.8,610.2,378.4,610.2,365z M642.8,365c0-5.7-3.1-8.6-7.1-8.6c-4,0-7.1,2.9-7.1,8.6c0,5.7,3.1,8.7,7.1,8.7 C639.7,373.7,642.8,370.7,642.8,365z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456E88"
    },
    d: "M698,342.4v16c-1.6-0.2-2.7-0.3-4-0.3c-5.4,0-9.3,2.5-9.3,9.5l0,19.5h-18.1l0-43.8h17.2v4.7 C687,344.2,691.9,342.4,698,342.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456E88"
    },
    d: "M700.1,330.4c0-5.2,4.2-9.2,10.9-9.2c6.7,0,10.9,3.7,10.9,8.9c0,5.5-4.2,9.5-10.9,9.5 C704.4,339.6,700.1,335.6,700.1,330.4z M701.9,343.2h18.1l0,43.8H702L701.9,343.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456E88"
    },
    d: "M760.4,385.5c-2.8,1.6-6.9,2.3-11.1,2.3c-12.1,0-19.2-5.7-19.2-17.8l0-11.2h-6v-13.2h6l0-12.3h18.1l0,12.3h9 v13.2h-9l0,11.1c0,2.7,1.6,4.2,3.8,4.2c1.4,0,2.9-0.4,4.1-1.2L760.4,385.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456E88"
    },
    d: "M813.5,343.2l-18,44.7c-4.8,12-11.9,15.5-21.2,15.5c-4.8,0-10.3-1.5-13.3-3.9l6-12.4c1.8,1.4,4.2,2.3,6.4,2.3 c2.2,0,3.5-0.6,4.5-1.8l-18.4-44.4h18.6l9.1,23.5l9.2-23.5L813.5,343.2z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHcraLogoColor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hcraLogoColor.9081b442.svg";
export { ForwardRef as ReactComponent };